var venues = [];

export default {
    getVenues () {
        if(typeof venues !== 'undefined' && venues.length > 0)
            return venues;

        const response = axios.get('camp-booking/venues').then(response => { return response.data.data });
        response.then(function(data) {
                return data;
            });
    },
}


// WEBPACK FOOTER //
// ./src/api/modules/venues.js